import { useState } from "react";

import { ReportSelectionCard } from "components";
import { fileResponseDownloader } from "utils/fileResponseDownloader";
import { LoadingButton } from "components";
import apiService from "services/api";
import { firstDay, lastDay } from "utils/dateHelper";

const initialState = {
	date_from: firstDay(undefined, "absolute_month"),
	date_to: lastDay(undefined, "absolute_month"),
	staff: undefined,
	grouped: false,
};

const apiCallMapper = {
	teacherSummary: apiService.report.teacherSummary,
	courseSummary: apiService.report.courseSummary,
	courseConfidenceStatistics: apiService.report.courseConfidenceStatistics,
	ludaAttendanceReport: apiService.report.ludaAttendanceReport,
};

const StaffReportsPage = () => {
	const [filterOptions, setFilterOptions] = useState(initialState);
	const [loading, setLoading] = useState(false);

	const transformParams = () => {
		const date_from = new Date(filterOptions.date_from).toISOString().slice(0, 10);
		const date_to = new Date(filterOptions.date_to).toISOString().slice(0, 10);
		const staff_id = filterOptions.staff?.value;
		return {
			staff_id,
			date_from,
			date_to,
			grouped: filterOptions.grouped,
		};
	};

	const handleChange = (e) =>
		setFilterOptions((prev) => ({
			...prev,
			[e.target.name]: e.target.value,
		}));

	const triggerDownload = (type) => {
		setLoading(true);
		let fileName = `${filterOptions.date_from ? filterOptions.date_from + "_" : ""}${
			filterOptions.date_to ? filterOptions.date_to + "_" : ""
		}teaching_hours.xlsx`;
		if (type === "ludaAttendanceReport") fileName = `${filterOptions.date_from}_${filterOptions.date_to}_luda_staff_attendance_report.xlsx`;
		apiCallMapper[type](transformParams(), filterOptions.grouped)
			.then((data) => {
				fileResponseDownloader({ fileName, data });
			})
			.finally(() => setLoading(false));
	};

	return (
		<div className="content">
			<ReportSelectionCard
				title="Report for Teacher Summary"
				handleChange={handleChange}
				filterOptions={filterOptions}
				setFilterOptions={setFilterOptions}
				buttons={
					<>
						<LoadingButton color="info" className="mr-2" disabled={loading} onClick={() => triggerDownload("teacherSummary")}>
							Generate Teacher Summary Report
						</LoadingButton>
					</>
				}
			/>
			<ReportSelectionCard
				title="Report for Course Summary"
				handleChange={handleChange}
				filterOptions={filterOptions}
				setFilterOptions={setFilterOptions}
				buttons={
					<>
						<LoadingButton color="info" className="mr-2" disabled={loading} onClick={() => triggerDownload("courseSummary")}>
							Generate Course Summary Report
						</LoadingButton>
					</>
				}
			/>

			<ReportSelectionCard
				title="Report for Course Confidence Statistics"
				handleChange={handleChange}
				filterOptions={filterOptions}
				setFilterOptions={setFilterOptions}
				buttons={
					<>
						<LoadingButton color="info" className="mr-2" disabled={loading} onClick={() => triggerDownload("courseConfidenceStatistics")}>
							Generate Course Confidence Statistics
						</LoadingButton>
					</>
				}
			/>

			<ReportSelectionCard
				title="Report for Luda Attendance"
				handleChange={handleChange}
				filterOptions={filterOptions}
				setFilterOptions={setFilterOptions}
				buttons={
					<>
						<LoadingButton color="info" className="mr-2" disabled={loading} onClick={() => triggerDownload("ludaAttendanceReport")}>
							Generate Luda Staff Attendance Records
						</LoadingButton>
					</>
				}
			/>
		</div>
	);
};

export default StaffReportsPage;
